import { QuickSlotSetupModal } from "@reconvert/react-ui-component";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import useConditions from "../../hooks/useConditions";
import { Slot } from "../../models";
import { SHOPIFY_API_KEY, SHOPIFY_APP_ID } from "../../config";
import { IFramePostMessageType, sendPostMessage } from "../../utils/helpers";
import { selectBannerState } from "../../app/slice/bannerSlice";

interface SlotSetupModalProps {
  isOpen: boolean;
  slot: Slot;
  onClose: () => void;
}

const SlotSetupModal = ({ isOpen, slot, onClose }: SlotSetupModalProps) => {
  const { activePage } = useAppSelector(selectAppState);
  const { slotStatuses } = useAppSelector(selectBannerState);
  const { selectedCondition } = useConditions();
  const { checkoutProfileId } = useAppSelector(selectAppState);
  const [slotStatusInfo, setSlotStatusInfo] = useState<{
    isLoading: boolean;
    isSuccess: boolean;
    slotStatus: any;
  }>({
    isLoading: false,
    isSuccess: false,
    slotStatus: null,
  });

  const [continueButtonInfo, setContinueButtonInfo] = useState({
    isDisabled: true,
  });

  useEffect(() => {
    if (isOpen) {
      setSlotStatusInfo({
        isLoading: false,
        isSuccess: false,
        slotStatus: null,
      });
      setContinueButtonInfo({
        isDisabled: true,
      });
    }
  }, [isOpen]);

  useEffect(() => { 
      if (slotStatuses) {
        const selectedSlotStatus = slotStatuses.find(
          (status: any) => status?.location === activePage && status?.slotNo === slot?.slotNo,
        );

        if (!selectedSlotStatus) {
          setSlotStatusInfo(prev => ({
            ...prev,
            isLoading: false,
            isSuccess: true,
          }));
          setContinueButtonInfo({
            isDisabled: false,
          });
        } else {
          setSlotStatusInfo(prev => ({
            ...prev,
            isLoading: false,
            isSuccess: false,
            slotStatus: "detected",
          }));
        }
      }
  }, [activePage, slot?.slotNo, slotStatuses])

  const checkStatus = useCallback(async () => {
    setSlotStatusInfo(prev => ({
      ...prev,
      isLoading: true,
    }));

    try {
      sendPostMessage(IFramePostMessageType.SYNC_SLOT_STATUS);
    } catch (error: any) {
      setSlotStatusInfo(prev => ({
        ...prev,
        isLoading: false,
        isSuccess: false,
        slotStatus: null,
      }));
    }
  }, []);

  const handleOnClose = useCallback(async () => {
    try {
      sendPostMessage(IFramePostMessageType.SYNC_SLOT_STATUS);
    } catch (error) {
      console.error("Error syncing slot status:", error);
    } finally {
      onClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editorRedirectionConfig = useMemo(
    () => ({
      shopifyApiKey: SHOPIFY_API_KEY || "",
      platformStoreId: selectedCondition?.platformStoreId || "",
      checkoutProfileId: checkoutProfileId || "",
      shopifyAppId: SHOPIFY_APP_ID || "",
    }),
    [selectedCondition?.platformStoreId, checkoutProfileId],
  );

  console.log("SLOT =>", slot);

  return (
    <QuickSlotSetupModal
      slotNumber={slot?.slotNo}
      activePage={activePage}
      onGoToEditor={{
        isDisabled: slotStatusInfo.isSuccess,
      }}
      checkStatusButton={{
        onClick: checkStatus,
        isLoading: slotStatusInfo.isLoading,
        isDisabled: slotStatusInfo.isLoading,
        isSuccess: slotStatusInfo.isSuccess,
      }}
      continueButton={{
        onClick: () => {
          handleOnClose();
        },
        isDisabled: continueButtonInfo.isDisabled,
      }}
      isOpen={isOpen}
      // @ts-ignore
      editorRedirectionConfig={editorRedirectionConfig}
      slotStatus={slotStatusInfo.slotStatus}
      onClose={handleOnClose}
      widgetType={slot?.type}
    />
  );
};

export default SlotSetupModal;
